
import React from 'react';
import { Dumbbell, MessageCircle, Phone, Mail, Instagram, Facebook, Map, Clock, QrCode, Sparkles } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const FitnessLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Dumbbell,
      title: "Planos de Treino",
      subtitle: "Descubra nossos programas",
      url: "https://decidedigital.com.br/",
      gradient: "from-orange-500 to-red-600"
    },
    {
      icon: Clock,
      title: "Horários & Aulas",
      subtitle: "Confira nossa programação",
      url: "https://decidedigital.com.br/",
      gradient: "from-green-500 to-teal-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Fitness",
      subtitle: "Tire suas dúvidas agora",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20a%20academia!",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      icon: Phone,
      title: "Contato Academia",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      icon: Mail,
      title: "E-mail",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-purple-500 to-pink-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-900 via-red-900 to-yellow-900 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="w-28 h-28 mx-auto mb-4 bg-gradient-to-br from-orange-400 to-red-600 rounded-full flex items-center justify-center shadow-2xl">
            <Dumbbell className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">FitLife Academy</h1>
          <div className="flex items-center justify-center gap-2 mb-3">
            <Sparkles className="w-4 h-4 text-orange-200" />
            <p className="text-orange-200 leading-relaxed text-sm">
              Transforme seu corpo, transforme sua vida! Academia completa com equipamentos modernos e instrutores qualificados.
            </p>
          </div>
        </div>

        {/* QR Code Section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6 text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <QrCode className="w-4 h-4 text-white" />
            <p className="text-white text-sm">Escaneie para acessar nosso site:</p>
          </div>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-5 h-5 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 bg-gradient-to-r ${link.gradient} rounded-2xl text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <link.icon className="w-6 h-6 mr-4" />
                <div className="flex-1">
                  <div className="font-semibold">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mt-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Map className="w-4 h-4 text-white" />
            <p className="text-white text-sm">Nossa localização:</p>
          </div>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={15} />
        </div>
      </div>
    </div>
  );
};

export default FitnessLinktree;
